import { Navigate, Route, Routes } from "react-router-dom";
import Collections from "./Collections/Collections";
import Scheduled from "./Scheduled/Scheduled";

/**
 * Containers coordinator surface (a.k.a. Logistics Manager). Mounted at `/containers/*`;
 * owns the two sub-routes reached from the "Containers" header dropdown.
 */
function LogisticsManager() {
  return (
    <Routes>
      <Route index element={<Navigate to="collections" replace />} />
      <Route path="collections" element={<Collections />} />
      <Route path="scheduled" element={<Scheduled />} />
      <Route path="*" element={<Navigate to="collections" replace />} />
    </Routes>
  );
}

export default LogisticsManager;
